export default {
    SET_REFERRAL_CODE: (state, referralCode) => {
        state.referralCode = referralCode
    },

    SET_REF_STATUS: (state, refStatus) => {
        state.refStatus = refStatus
    }
}
